import {ActionTypes} from '../actions';
import createReducer from '../../common/util/createReducer';

const INITIAL_STATE = {
  'tccSale': {},
  'tccSaleVehicle': {},
  'recordSale': [],
  'loading': false,
};


export const tccSale = (state, action) => {
  return createReducer(INITIAL_STATE, {
    [ActionTypes.FETCHING_VEHICLE_CERTIFICATION_SALE]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_VEHICLE_CERTIFICATION_SALE]: (state, action) => ({
      ...state,
      'loading': false,
      'tccSale': action.response.data,
    }),
    [ActionTypes.FETCHED_VEHICLE_CERTIFICATION_SALE_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'tccSale': {},
    }),
    [ActionTypes.FETCHING_VEHICLE_CERTIFICATION_BY_ID]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_VEHICLE_CERTIFICATION_BY_ID]: (state, action) => ({
      ...state,
      'loading': false,
      'tccSaleVehicle': action.response.data,
    }),
    [ActionTypes.FETCHED_VEHICLE_CERTIFICATION_BY_ID_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'tccSaleVehicle': {},
    }),
    [ActionTypes.CLEAR_VEHICLE_CERTIFICATION_SALE]: (state, action) => ({
      ...state,
      'loading': false,
      'tccSaleVehicle': {},
    }),
    [ActionTypes.FETCHING_VEHICLE_RECORD_SALE]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_VEHICLE_RECORD_SALE]: (state, action) => ({
      ...state,
      'loading': false,
      'recordSale': action.response.data,
    }),
    [ActionTypes.FETCHED_VEHICLE_RECORD_SALE_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'recordSale': [],
    }),
  })(state, action);
};

